import { gql } from "@apollo/client";

export const AI_RECRUITER_JOB_STATUS = gql`
  query AiRecruiterJobStatus {
    aiRecruiterJobStatus {
      jobs {
        jobName
        lastRun {
          status
          startedAt
          finishedAt
          durationMs
          outcome
          errorMessage
        }
      }
      gauges {
        emailQueuePending
        emailDeadLetter
        stuckInQueue
      }
    }
  }
`;

export const AI_RECRUITER_DEAD_LETTERED_EMAILS = gql`
  query AiRecruiterDeadLetteredEmails($limit: Int) {
    aiRecruiterDeadLetteredEmails(limit: $limit) {
      id
      recipient
      emailType
      sourceId
      attemptCount
      deadLetterReason
      deadLetteredAt
      createdAt
    }
  }
`;

export const AI_RETRY_DEAD_LETTERED_EMAIL = gql`
  mutation AiRetryDeadLetteredEmail($id: ID!) {
    aiRetryDeadLetteredEmail(id: $id)
  }
`;
